import { issueLoaders } from './issues';
import { projectPDFLoaders } from './pdf';
import { repriceLoaders } from './projectReprice';
import { projectTeamLoaders } from './projectTeam';
import { projectsLoaders, ProjectsByStatusLoadParams } from './projects';
import { recruitmentLoaders } from './recruitment';
import { sampleLoaders } from './sample';
import { taskExcludedIdsLoaders } from './taskExcludedIds';
import { taskLoaders } from './tasks';

export type { ProjectsByStatusLoadParams };

export const projectLoaders = {
  ...projectPDFLoaders,

  ...taskExcludedIdsLoaders,

  ...taskLoaders,

  ...projectsLoaders,

  ...repriceLoaders,

  ...recruitmentLoaders,

  ...sampleLoaders,

  ...issueLoaders,

  ...projectTeamLoaders,
};
